import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import NotificationComponent from '../components/Notification/Notification';
import {clearNotification} from '../actions/Notification';

class Notification extends Component {

    onCloseButtonClick = () => this.props.clearNotification();

    render() {
        return(
            <NotificationComponent
                notification={this.props.notification}
                onCloseButtonClick= {this.onCloseButtonClick} />
        );
    }
}

Notification.propTypes = {
    notification: PropTypes.shape({
        message: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.string
    }),
    clearNotification: PropTypes.func
};

const mapStateToProps = (state) => {
   return{
       notification: state.notification
   };
};
   
const mapDispatchToProps = (dispatch) => {
    return {
        clearNotification: () => dispatch(clearNotification()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Notification);


// WEBPACK FOOTER //
// ./src/containers/Notification.js